// @flow

import React, { type ComponentType } from 'react';
import styled from 'styled-components';
import InputComponent from '../input';
import type { Theme } from '../../../types';

const PrefixLabel: ComponentType<*> = styled<any, Theme>('label')`
  text-align: center;
  box-sizing: border-box;
  height: 2.5rem;
  line-height: 2.5rem;
  width: 1.75rem;
  color: ${props => props.theme.form.prefixedInput.color};
  border: 1px solid ${props => props.theme.form.prefixedInput.border};
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  min-width: 2rem;
`;

const Input: ComponentType<*> = styled<typeof InputComponent, Theme>(InputComponent)`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: none;
  width: calc(100% - 2rem);
`;

const InputContainer = styled<any, Theme>('div')`
  display: flex;
  flex-direction: row;
`;

type Props = {
  prefix?: string,
  error?: boolean,
  valid?: boolean,
  value?: string,
  onChange?: Function,
};

const PrefixedInput = ({
  prefix = '€',
  error = false,
  value = '',
  valid = false,
  onChange,
}: Props) => (
  <InputContainer>
    <PrefixLabel>
      {prefix}
    </PrefixLabel>
    <Input onChange={onChange} value={value} error={error} valid={valid} />
  </InputContainer>
);

PrefixedInput.defaultProps = {
  value: '',
  prefix: '€',
  error: false,
  valid: false,
  onChange: () => null,
};

export default PrefixedInput;
